import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionTitle from 'components/Credit24/SelfService/Navigation/SectionTitle';

const propTypes = {
  authentication: PropTypes.object,
};

const CreditInformationTitleContainer = ({ authentication }) => (
  <SectionTitle
    titleKey="selfservice.creditInformation.title"
    customerId={authentication.customerNumber}
  />
);

CreditInformationTitleContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    authentication: state.authentication,
  })
)(CreditInformationTitleContainer);
